import React from 'react'
import {CardExpert} from '../../component/fiture'
import {Expert} from '../../assets/img'
import Slider from 'react-slick'
import {settings , Experts} from '../../utilities'

import './expert.scss'

function Index() {

    const Scroll = () => window.scrollTo({behavior : 'smooth' , top : 0})

    return (
        <div className='expert'>
            <div className='jumbotron' style={{backgroundImage : `url(${Expert})`}}>
                <h3 className='title'>EXPERTS</h3>
            </div>

            <div className='content'>
                <h3 className='title'>Our Good Impactor</h3>

                <Slider {...settings}>
                   {Experts.map(item => <CardExpert data={item} />)}
                </Slider>
            </div>

            <div className='info'>
                <h3 className='title'>With Hands-on Practitioners</h3>

                <p className='body'>Participants will also enjoy the experience of learning from Dattabot's unique and passionate
                    young practitioners. They are individuals who have proven to be adaptable and skilled facilitators who will ensure
                     that the courses are run interactively, contemporary, & with fun.
                </p>
            </div>

            <span className='back' onClick={Scroll}>Kembali Ke Atas</span>
        </div>
    )
}

export default Index
